import React from "react";

function SelectorDeclaracion({ calendariosActivos, calendarioSeleccionadoIdx, onSeleccionar }) {
  if (calendariosActivos.length === 0) {
    return (
      <div style={{ background: 'linear-gradient(135deg, #fff8e1, #fff3e0)', border: '1px solid #ffcc02', borderRadius: '14px', padding: '28px', textAlign: 'center', marginBottom: '16px', boxShadow: '0 2px 12px rgba(255,152,0,0.1)' }}>
        <div style={{ width: '50px', height: '50px', borderRadius: '50%', background: '#FFF3E0', border: '2px solid #FF9800', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="fas fa-clock" style={{ color: '#E65100', fontSize: '1.3rem' }}></i>
        </div>
        <div style={{ fontSize: '1rem', fontWeight: '700', color: '#E65100', marginBottom: '4px' }}>Sin declaraciones abiertas</div>
        <div style={{ fontSize: '0.82rem', color: '#bf360c' }}>No hay declaraciones juradas habilitadas en este momento.</div>
      </div>
    );
  }

  if (calendariosActivos.length === 1) {
    return (
      <div style={{ background: 'linear-gradient(135deg, #1B5E20, #388E3C)', borderRadius: '14px', padding: '22px 28px', textAlign: 'center', marginBottom: '16px', boxShadow: '0 4px 16px rgba(46,125,50,0.25)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
          <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="fas fa-file-signature" style={{ color: '#fff', fontSize: '1.2rem' }}></i>
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.72rem', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>Declaracion Jurada Habilitada</div>
            <div style={{ color: '#fff', fontWeight: '700', fontSize: '1.1rem' }}>{calendariosActivos[0].nombre} {calendariosActivos[0].anio}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ fontSize: '0.82rem', fontWeight: '600', color: '#555', marginBottom: '10px' }}>
        <i className="fas fa-hand-pointer mr-2" style={{ color: '#7A1622' }}></i>Seleccione la declaracion:
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {calendariosActivos.map(function(cal, i) {
          var seleccionado = calendarioSeleccionadoIdx === i;
          return (
            <div key={i}
              onClick={function() { onSeleccionar(i); }}
              style={{
                flex: '1 1 180px',
                border: seleccionado ? '2px solid #2E7D32' : '2px solid #e0e0e0',
                borderRadius: '12px',
                padding: '16px',
                cursor: 'pointer',
                background: seleccionado ? 'linear-gradient(135deg, #1B5E20, #388E3C)' : '#fff',
                textAlign: 'center',
                transition: 'all 0.2s',
                boxShadow: seleccionado ? '0 4px 12px rgba(46,125,50,0.25)' : '0 2px 6px rgba(0,0,0,0.05)'
              }}>
              <i className={seleccionado ? 'fas fa-check-circle' : 'far fa-circle'}
                style={{ fontSize: '1.2rem', color: seleccionado ? '#fff' : '#ccc', display: 'block', marginBottom: '6px' }}></i>
              <div style={{ fontWeight: '700', fontSize: '0.83rem', color: seleccionado ? '#fff' : '#333' }}>
                {cal.nombre} {cal.anio}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SelectorDeclaracion;
